import React from 'react';
import Toggle from './Toggle';

/**
 * Card de toggle padronizado — ícone + título + switch.
 * Reusa o CSS global .anti-clone-toggle (toggleAntiClone.css).
 *
 * @param {string|React.ReactElement} icon  classes do Font Awesome (ex:
 *        "fas fa-shield-alt") OU um elemento de ícone Lucide (ex: <Zap size={16}/>)
 * @param {string}  title    texto do rótulo
 * @param {boolean} checked  estado
 * @param {func}    onChange (checked:boolean) => void
 */
export default function ToggleCard({ icon, title, checked = false, onChange }) {
    return (
        <div className="anti-clone-toggle anti-clone-toggle--compact">
            <div className="anti-clone-info">
                {icon && (typeof icon === 'string'
                    ? <i className={`${icon} anti-clone-icon`} />
                    : <span className="anti-clone-icon">{icon}</span>)}
                <span className="text-sm font-semibold text-white">{title}</span>
            </div>
            <Toggle className="toggle-sm" checked={checked} onChange={onChange} />
        </div>
    );
}
